{"dirty":false,"raw":"ac2dca879","hash":"ac2dca879","distance":null,"tag":null,"semver":null,"suffix":"ac2dca879","semverString":null}